import React from 'react';
import { motion } from 'framer-motion';
import { 
  BuildingOfficeIcon,
  ChartBarIcon,
  GlobeEuropeAfricaIcon 
} from '@heroicons/react/24/outline';

const CoreValues = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-800 to-gray-900 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <motion.div
          className="mt-20"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h3 className="text-4xl font-bold text-center mb-12 text-white">
            Our Core Values
          </h3>

          <div className="grid md:grid-cols-3 gap-8">
            <motion.div
              className="text-center p-8 bg-gradient-to-r from-purple-600/10 to-violet-600/10 backdrop-blur-lg rounded-3xl border border-purple-500/20"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-violet-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <BuildingOfficeIcon className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-2xl font-bold text-white mb-4">Transparency</h4>
              <p className="text-gray-300 leading-relaxed">
                Every investment, every decision, every return is transparent and verifiable through blockchain technology.
              </p>
            </motion.div>

            <motion.div
              className="text-center p-8 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 backdrop-blur-lg rounded-3xl border border-cyan-500/20"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <ChartBarIcon className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-2xl font-bold text-white mb-4">Excellence</h4>
              <p className="text-gray-300 leading-relaxed">
                We maintain the highest standards in property selection, due diligence, and investment management.
              </p>
            </motion.div>

            <motion.div
              className="text-center p-8 bg-gradient-to-r from-green-600/10 to-emerald-600/10 backdrop-blur-lg rounded-3xl border border-green-500/20"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.3 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <GlobeEuropeAfricaIcon className="w-8 h-8 text-white" />
              </div>
              <h4 className="text-2xl font-bold text-white mb-4">Innovation</h4>
              <p className="text-gray-300 leading-relaxed">
                Pioneering the future of real estate investment through cutting-edge blockchain technology.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CoreValues;